import BreadCrumb from "Components/Common/BreadCrumb";
import "react-toastify/dist/ReactToastify.css";
import { Card, Container } from "reactstrap";
import "./MarketingCampaign.scss";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getRegisteredCampaignThunk } from "live-slices/thunk";
import { getMarketingRegistered } from "helpers/backend_helper";

const CampaignData = (props: any) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [totalCount, settotalCount] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const itemsPerPage = 10;
  const dispatch: any = useDispatch();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loadingCampaign, setLoadingCampaign] = useState<boolean>(true);
  const [apiData, setApiData] = useState<any[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const navigate = useNavigate();
  const [selectedCampaignId, setSelectedCampaignId] = useState<string>('');

  const handleSelectChange = (event: any) => {
    const selectedCampaign = event.target.value;
    setSelectedCampaignId(selectedCampaign)
    dispatch(
      getRegisteredCampaignThunk({
        page: 1,
        count: 10,
        campaignId: selectedCampaignId,
      })
    );
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const getCompaign = async (page: number) => {
    try {
      setLoadingCampaign(true);
      const response: any = await getMarketingRegistered(page, itemsPerPage, selectedCampaignId);
      if (response?.data && response.isSuccess) {
        setApiData(response.data.data);
        settotalCount(response.data.totalCount);
        setTotalPages(Math.ceil(response.data.totalCount / itemsPerPage));
      } else {
        setApiData([]);
      }
    } catch (err: any) {
      setLoadingCampaign(false);
      setApiData([]);
    } finally {
      setLoadingCampaign(false);
    }
  };

  useEffect(() => {
    getCompaign(currentPage)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, currentPage, selectedCampaignId]);

  return (
    <div className="page-content SubmissionHistoryMainPage">
      <Container fluid>
        <BreadCrumb
          title="Campaign Performance"
          pageTitle="Promotion"
          pageTitleRoute="/promotion"
        />
        <Card className="SubmissionHistoryMainCard">
          <div className="searchAndSelect">
            <div className="input">
              <input
                type="text"
                placeholder="Campaigns"
                data-testing-id="searchInput_CampaignData"
              />
            </div>
            <select data-testing-id="selectOption_CampaignData" onChange={handleSelectChange}>
              <option disabled selected>
                Select a campaign
              </option>
              {apiData && apiData.length > 0 ? (
                apiData.map((item: any, index: number) => (
                  <option
                    value={item?.campaign?._id}
                    data-testing-id="pleaseSelectOption_CampaignData"
                  >
                    {item?.campaign?.name}
                  </option>
                ))
              ) : (
                <></>
              )}
            </select>
          </div>
        </Card>
        <Card className="SubmissionHistoryMainCard">
          <h1>Campaign Performance</h1>
          <div className="SubmissionHistoryListing_Main">
            <table className="w-100">
              <thead>
                <tr>
                  <th className="top-left">
                    <p>
                      <span>Campaign ID</span>
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Campaign Name</span>
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Product Visitors</span>
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Add to card users</span>
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Add to cart units</span>
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Revenue</span>
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Orders</span>
                    </p>
                  </th>{" "}
                  <th>
                    <p>
                      <span>Buyers</span>
                    </p>
                  </th>{" "}
                  <th>
                    <p>
                      <span>Conversion rate</span>
                    </p>
                  </th>
                  <th>
                    <p>
                      <span>Units Sold</span>
                    </p>
                  </th>
                  <th className="top-right">
                    <p>
                      <span>Avg. order value</span>
                    </p>
                  </th>
                </tr>
              </thead>
              <tbody>
                {apiData && apiData.length > 0 ? (
                  apiData.map((item: any, index: number) => (
                    <tr key={index}>
                      <td><p>{item.campaign._id}</p></td>
                      <td><p>{item.campaign.name}</p></td>
                      <td><p>{item.productUserIds.length}</p></td>
                      <td><p>{item.cartUserIds.length}</p></td>
                      <td><p>{item.cartUnits}</p></td>
                      <td><p>{item.revenue}</p></td>
                      <td><p>{item.orderCount}</p></td>
                      <td><p>{item.cartUserIds.length}</p></td>
                      <td><p>{item.conversionRate}</p></td>
                      <td><p>{item.unitSold}</p></td>
                      <td><p>{item.averageOrderValue}</p></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td style={{ textAlign: 'center' }}>No Data Found</td>
                  </tr>

                )}
              </tbody>
            </table>
          </div>
          <div className="paginationDv mt-4 d-flex justify-content-end">
            <nav aria-label="Page navigation example">
              <ul className="pagination detailPagepagi m-0">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""
                    }`}
                >
                  <button
                    onClick={() => handlePrevious()}
                    style={{
                      height: "26px",
                      display: "flex",
                      alignItems: "center",
                      border: "none",
                    }}
                    className="page-link"
                  >
                    <i
                      style={{ height: "11px" }}
                      className="bx bxs-left-arrow"
                    ></i>
                  </button>
                </li>

                {Array.from({ length: totalPages }, (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${currentPage === i + 1 ? "active" : ""
                      }`}
                  >
                    <button
                      onClick={() => handlePageChange(i + 1)}
                      className="page-link orderPg"
                      style={{ height: "26px" }}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}

                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""
                    }`}
                >
                  <button
                    onClick={() => handleNext()}
                    className="page-link orderPg"
                    style={{
                      height: "26px",
                      display: "flex",
                      alignItems: "center",
                      border: "none",
                    }}
                  >
                    <i
                      className="bx bxs-right-arrow"
                      style={{ width: "6px", height: "11px" }}
                    ></i>
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default CampaignData;
